import { Logo } from "./Logo";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-gold/15 bg-ink2">
    <div className="mx-auto flex max-w-[1400px] flex-col gap-10 px-5 py-14 sm:px-10 md:flex-row md:items-end md:justify-between">
      <div>
        <Logo />
        <p className="mt-5 max-w-xs font-display text-xl italic text-stone2">Rooted in tradition. Reimagined for royalty. Worn with pride.</p>
      </div>
      <div className="flex flex-col gap-3 md:items-end">
        <a href="https://hilmays-kabas.emergent.host/" target="_blank" rel="noopener noreferrer" data-testid="footer-heritage-link"
          className="font-mono text-[11px] uppercase tracking-[0.3em] text-gold transition-colors duration-300 hover:text-goldlight">
          Read the history of the kaba →
        </a>
        <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-stone2">© {new Date().getFullYear()} Hilmay’s Kabas</p>
        <p data-testid="footer-byline" className="font-display text-2xl italic text-white">By Soliyana Hilmay</p>
      </div>
    </div>
  </footer>
);
